const LightData = {
  color: 0xffffff,
  intensity: 1,
};

const CamData = {
  fov: 50,
  near: 1,
  far: 5000,
};

module.exports = { LightData, CamData }
